

import styled, { css } from 'styled-components';
import { Colors, FInter, FlexBox } from '@brg/ui';
//тень от меню
export const OptionsBoxShadow = styled.div`
    background: ${(p) => p.theme.inputs.optionsBox.shadowColor};
    border-radius: 3px;
    height: 28px;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    pointer-events: none;
`;
//фрейм выпадающего меню
export const OptionsBoxWrapper = styled.div`
    // color: ${Colors.geoWhite100};
    user-select: none;
    position: absolute;
    width: 100%;
    z-index: 1001;
`;
//лист опций
export const OptionsBoxListWrapper = styled.div`
    color: ${(p) => p.theme.dropdown.textColor} !important;
    background: ${(p) => p.theme.inputs.backgroundColor};
    box-shadow: 0px 1px 4px rgba(7, 7, 7, 0.17);
    border-radius: 3px;
    border: 1px solid ${(p) => p.theme.inputs.optionsBox.borderColor};
    position: relative;
    max-height: 270px;
    overflow-y: scroll;
    user-select: none;
`;

// Опция по умолчанию
export const OptionBoxWrapper = styled(FInter.SmallTextDiv)<{ tabIndex: number }>`
    color: ${(p) => p.theme.dropdown.textColor} !important;
    tab-index: ${(p) => p.tabIndex};
    padding: 13px 16px;
    padding-top: 15px;
    cursor: pointer;
    background: transparent;
    user-select: none;
`;

// Опция при наведении мыши
export const OptionBoxHoverWrapper = styled(OptionBoxWrapper)`
    background: rgba(31, 31, 31, 0.31);
    user-select: none;
`;
//стрелочка
export const DropdownIndicatorBoxWrapper = styled(FlexBox)<{ isActive?: boolean }>`
    cursor: pointer;
    transition: all 0.2s;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    margin: 4px;
    user-select: none;

    svg {
        transition: all 0.2s;
    }
    svg path {
        fill: ${Colors.geoWhite47};
    }
    &:hover {
        svg path {
            fill: ${Colors.geoWhite100};
        }
    }
    ${(p) =>
        p.isActive
            ? css`
                  svg {
                      transform: rotate(180deg);
                  }
                  svg path {
                      fill: ${Colors.geoWhite47};
                  }
              `
            : null};
`;
//фрейм селект бокса
export const SelectBoxControlWrapper = styled.div<{ isFocused?: boolean }>`
    display: flex;
    background: ${(p) => p.theme.inputs.backgroundColor};
    border: ${(p) =>
        p.isFocused ? '1px solid ' + p.theme.inputs.borderFocusedColor : '1px solid ' + p.theme.inputs.borderColor};
    box-sizing: border-box;
    border-radius: 3px;
    transition: all 0.2s;
    width: 100%;
    color: ${(p) => p.theme.dropdown.textColor} !important;
    height: 48px;
    input {
        color: ${(p) => p.theme.dropdown.textColor} !important;
    }
    &:hover {
        ${DropdownIndicatorBoxWrapper} svg path {
            fill: ${Colors.geoWhite100};
        }

        .bg__placeholder {
            color: ${Colors.geoWhite47};
        }
    }

    .bg__value-container {
        padding-left: 16px;
    }

    .bg__input,
    .bg__single-value {
        color: ${(p) => p.theme.dropdown.textColor} !important;
    }

    .bg__placeholder {
        color: ${(p) => p.theme.dropdown.textColor} !important;
    }
`;
//фрейм выбора тегов
export const TagBoxControlWrapper = styled(SelectBoxControlWrapper)`
    .bg__value-container {
        overflow-x: auto;
    }
`;
//текст ввода в инпут
export const SelectBoxInputDisplayWrapper = styled(FInter.SmallTextDiv)`
    color: ${(p) => p.theme.dropdown.textColor};
`;
//обертка тега
export const MultiValueWrapper = styled.div`
    margin-right: 8px;
    .tag-wrap {
        border: 1px solid rgba(254, 254, 254, 0.13) !important;
    }
`;
//обертка тегов
export const TagsBoxValueContainerWrapper = styled.div`
    &::-webkit-scrollbar {
        display: none;
    }
    display: flex;
    flex: 1;
    align-items: center;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    //padding: 0 12px;
    margin-left: 12px;
    width: 100%;
    height: 48px;
    .tag-wrap {
        box-sizing: border-box;
    }
`;


import styled, { css } from 'styled-components';
import { Colors, FInter, FlexBox } from '@brg/ui';
//тень от меню
export const OptionsBoxShadow = styled.div`
    background: ${(p) => p.theme.inputs.optionsBox.shadowColor};
    border-radius: 3px;
    height: 28px;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    pointer-events: none;
`;
//фрейм выпадающего меню
export const OptionsBoxWrapper = styled.div`
    // color: ${Colors.geoWhite100};
    user-select: none;
    position: absolute;
    width: 100%;
    z-index: 1001;
`;
//лист опций
export const OptionsBoxListWrapper = styled.div`
    color: ${(p) => p.theme.dropdown.textColor} !important;
    background: ${(p) => p.theme.inputs.backgroundColor};
    box-shadow: 0px 1px 4px rgba(7, 7, 7, 0.17);
    border-radius: 3px;
    border: 1px solid ${(p) => p.theme.inputs.optionsBox.borderColor};
    position: relative;
    max-height: 270px;
    overflow-y: scroll;
    user-select: none;
`;

// Опция по умолчанию
export const OptionBoxWrapper = styled(FInter.SmallTextDiv)<{ tabIndex: number }>`
    color: ${(p) => p.theme.dropdown.textColor} !important;
    tab-index: ${(p) => p.tabIndex};
    padding: 13px 16px;
    padding-top: 15px;
    cursor: pointer;
    background: transparent;
    user-select: none;
`;

// Опция при наведении мыши
export const OptionBoxHoverWrapper = styled(OptionBoxWrapper)`
    background: rgba(31, 31, 31, 0.31);
    user-select: none;
`;
//стрелочка
export const DropdownIndicatorBoxWrapper = styled(FlexBox)<{ isActive?: boolean }>`
    cursor: pointer;
    transition: all 0.2s;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    margin: 4px;
    user-select: none;

    svg {
        transition: all 0.2s;
    }
    svg path {
        fill: ${Colors.geoWhite47};
    }
    &:hover {
        svg path {
            fill: ${Colors.geoWhite100};
        }
    }
    ${(p) =>
        p.isActive
            ? css`
                  svg {
                      transform: rotate(180deg);
                  }
                  svg path {
                      fill: ${Colors.geoWhite47};
                  }
              `
            : null};
`;
//фрейм селект бокса
export const SelectBoxControlWrapper = styled.div<{ isFocused?: boolean }>`
    display: flex;
    background: ${(p) => p.theme.inputs.backgroundColor};
    border: ${(p) =>
        p.isFocused ? '1px solid ' + p.theme.inputs.borderFocusedColor : '1px solid ' + p.theme.inputs.borderColor};
    box-sizing: border-box;
    border-radius: 3px;
    transition: all 0.2s;
    width: 100%;
    color: ${(p) => p.theme.dropdown.textColor} !important;
    height: 48px;
    input {
        color: ${(p) => p.theme.dropdown.textColor} !important;
    }
    &:hover {
        ${DropdownIndicatorBoxWrapper} svg path {
            fill: ${Colors.geoWhite100};
        }

        .bg__placeholder {
            color: ${Colors.geoWhite47};
        }
    }

    .bg__value-container {
        padding-left: 16px;
    }

    .bg__input,
    .bg__single-value {
        color: ${(p) => p.theme.dropdown.textColor} !important;
    }

    .bg__placeholder {
        color: ${(p) => p.theme.dropdown.textColor} !important;
    }
`;
//фрейм выбора тегов
export const TagBoxControlWrapper = styled(SelectBoxControlWrapper)`
    .bg__value-container {
        overflow-x: auto;
    }
`;
//текст ввода в инпут
export const SelectBoxInputDisplayWrapper = styled(FInter.SmallTextDiv)`
    color: ${(p) => p.theme.dropdown.textColor};
`;
//обертка тега
export const MultiValueWrapper = styled.div`
    margin-right: 8px;
    .tag-wrap {
        border: 1px solid rgba(254, 254, 254, 0.13) !important;
    }
`;
//обертка тегов
export const TagsBoxValueContainerWrapper = styled.div`
    &::-webkit-scrollbar {
        display: none;
    }
    display: flex;
    flex: 1;
    align-items: center;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    //padding: 0 12px;
    margin-left: 12px;
    width: 100%;
    height: 48px;
    .tag-wrap {
        box-sizing: border-box;
    }
`;
